module.exports = __webpack_public_path__ + "img/支付.c2ba659e.png";